import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import style from '../../scss/login.module.scss';
import VideoCover from 'react-video-cover';
import { Icon } from "@iconify/react";
import { TextsContext } from '../../context/textsContext';
import LanguageDropdown from "../../components/LanguageDropdown";
import { useNavigate } from "react-router-dom";
import MenuComponent from "../../components/MenuComponent";
import StyleGrid from "../../scss/grid.module.scss";
import { useAuth } from "../../context/userContext";
import DialogComponent from "../../components/DialogComponent";
import { TitleH3Component } from "components/TitleH3Component";
import { BrowserView, MobileView } from "react-device-detect";
import { LoginForm } from "./components/LoginForm";
import { ComingSoon } from "./components/ComingSoon";
import Loader from "components/LoaderComponent";

const LoginPage = () => {
    const { texts, verifyCurrentLanguage, loaded } = useContext(TextsContext);
    const navigate = useNavigate();
    const { user } = useAuth();
    const hHeader = useRef(null);
    const [hamburger, sethamburger] = useState(true)

    const [modalvalidation, setModalvalidation] = useState(false);
    const handleClose = () => setModalvalidation(false);

    let canShow = true;
    useEffect(() => {
        if (user) {
            navigate("/home");
        }
    }, [])

    useEffect(() => {
        verifyCurrentLanguage();
    }, []);

    try {
        if (loaded && JSON.parse(texts?.des_key) === true) {
            canShow = false;
        }
    } catch (error) {
        canShow = true;
    }

    return (
        <Fragment>
            <div className={style.home}>
                {/* {isMobile && isIOS && 
                    <div>
                        es mobile
                    </div>
                } */}
                <MobileView className={style.videoFondoContent}>
                    <img src={'/img/fondo-video.jpg'} alt={'img fondo login'} className={style.videoFondo} />
                </MobileView>
                <BrowserView>
                    <img
                        src="/video/home.gif"
                        alt="Fondo animado"
                        className={style.video}
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            objectFit: 'cover',
                        }}
                    />
                </BrowserView>

                <div className={style.contenidoLogin}>
                    <div className={` d-md-none ${StyleGrid.wpMenu} ${!hamburger ? StyleGrid.active : null}`} ref={hHeader}>
                        <div className={StyleGrid.wpScroll}>
                            <MenuComponent sethamburger={sethamburger} hamburger={hamburger} menuLogin />
                        </div>
                    </div>
                    <section>
                        <div className="container d-none d-md-block">
                            <header className='py-4'>
                                <div className="container">
                                    <div className={style.headerbtn}>
                                        <img className={`${style.logoHeader}`} src={'/icons/my_vip_care_navbar_logo.svg'} alt={'img logo vumi'} />
                                        <div className='d-md-flex align-items-center d-none '>
                                            <LanguageDropdown />
                                        </div>
                                    </div>
                                </div>
                            </header>
                        </div>
                    </section>

                    {!loaded ? <Loader /> : (
                        <>
                            <LoginForm setModalvalidation={setModalvalidation} canShow={canShow} />
                        </>
                    )}
                    <section>

                    </section>
                    <section>
                        <DialogComponent
                            show={modalvalidation}
                            onClose={handleClose}
                            onConfirm={handleClose}
                            confirmText={texts?.modal_boton_closed ?? 'Closed'}
                        >
                            <Icon icon="mdi:alert-circle-outline" width={40} height={40} style={{ color: '#F12B24' }} className="mb-3" />
                            <TitleH3Component styleGroup="raleway fw_700 color_primary_2 mb-0">
                                {'Usuario o Contraseña incorrecta'}
                            </TitleH3Component>
                        </DialogComponent>
                    </section>
                </div>
 

            </div>
        </Fragment>
    )
}

export default LoginPage;